export default __webpack_public_path__ + "static/media/ThaiHealth-1.b187b9c3.jpg";